import * as Reflux from "reflux";
export const SideCaddyActions = {
	trackEnabled: Reflux.createAction(["trackEnabled"]),
	trackGoToCart: Reflux.createAction(["trackGoToCart"]),
	setItemQuantity: Reflux.createAction(["setItemQuantity"]),
	deleteItem: Reflux.createAction(["deleteItem"]),
};
